import React from 'react';
import LogoSrc from '../img/pixels-and-print-logo.png';
import { Link } from 'react-scroll';

function Logo(props) {
	return (
		<Link to="top" spy={true} smooth={true} duration={500}><img src={LogoSrc} alt="Pixels and Print logo" className="logo" /></Link>
		)
}
export default Logo;
